// extracted by mini-css-extract-plugin
export default {"spinner":"SearchDonorsScreen_spinner__Lt2HC"};